import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

export const PremiumListItemButton = styled(Button)`
  background: var(--backgroundA-2);

  --button-radius-rounded: 6px;

  height: 30px;
  padding-inline: 14px;
  font-weight: 600;
  border-radius: 4px;
  font-size: 10px;

  &:hover {
    background: var(--backgroundA-3);
  }

  &:disabled {
    background-color: var(--backgroundA-2);
    color: var(--textA-7);
  }
`
